module.exports = __webpack_public_path__ + "static/media/camera_icon.f1091a61.svg";